import React from 'react'
import { Container, Grid } from '@mui/material'
import 'tachyons'
import Profile from './components/Profile/Profile'
import Header from './components/Header/Header'
import Resume from './pages/Resume/Resume'
import Portfolio from './pages/Portfolio/Portfolio'
import Footer from './components/Footer/Footer'
import Contact from './pages/Contact/Contact'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css'
import Fade from 'react-reveal/Fade'
import Jump from 'react-reveal/Jump'
import Main from './components/Main/Main'
import About from './pages/About/About'
import Error from "./pages/Error/Error";

function App () {
  return (
    <div>
      <BrowserRouter>
        <Container className='mv5 App'>
          <Grid container spacing={3}>
            {/* profile component goes here */}

            <Grid item xs={12} sm={12} md={4} lg={3}>
              <Fade left>
                <Profile />
              </Fade>
            </Grid>

            <Grid item xs className='main-container'>
              <Header />
              <Fade right>
              <Main>
                <Routes>
                <Route path='/' element={<About />} />
                  <Route path='/resume' element={<Resume />} />
                  <Route path='/portfolio' element={<Portfolio />} />
                  <Route path='/contact' element={<Contact />} />
                  <Route path='*' element={<Error />} />
                </Routes>
              </Main>
              </Fade>
              <Jump>
                <Footer />
              </Jump>
            </Grid>
          </Grid>
        </Container>
      </BrowserRouter>
    </div>
  )
}

export default App
